import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/HR';
import { overview } from './overview/HR';
import { productInfoBox } from './productInfoBox/HR';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    dashboard,
    overview,
    productInfoBox,
};
